// extracted by mini-css-extract-plugin
module.exports = {"markdown":"markdown-renderer_markdown__1fiSZ"};